// extracted by mini-css-extract-plugin
export var badge = "_vc-4";
export var selected = "_vc-1";
export var selectedOverlay = "_vc-5";
export var thumbnailButton = "_vc-0";
export var thumbnailFallback = "_vc-3";
export var thumbnailImage = "_vc-2";